import tailwindPlugin from "tailwindcss/plugin";
export const plugin = tailwindPlugin(({ addBase, addComponents, theme, addVariant })=>{
    var _theme_base, _theme, _theme_3xl, _theme1, _theme_2xl, _theme2, _theme_xl, _theme3, _theme_lg, _theme4, _theme_base1, _theme5, _theme_base2, _theme6, _theme_4xl, _theme7, _theme_3xl1, _theme8;
    var _theme_base_, _theme_3xl_, _theme_2xl_, _theme_xl_, _theme_lg_, _theme_base_1, _theme_base_2, _theme_4xl_, _theme_3xl_1;
    /**
     * BASE:
     * Adds base Sharp styles
     */ addBase({
        'html': {
            scrollBehavior: 'smooth',
            // Font smoothing (antialiasing)
            '-webkit-font-smoothing': 'antialiased',
            '-moz-osx-font-smoothing': 'grayscale'
        },
        'body': {
            color: theme('colors.gray.700'),
            fontWeight: theme('fontWeight.medium'),
            fontSize: theme('fontSize.base'),
            lineHeight: (_theme_base_ = (_theme = theme('fontSize')) === null || _theme === void 0 ? void 0 : (_theme_base = _theme.base) === null || _theme_base === void 0 ? void 0 : _theme_base[1]) !== null && _theme_base_ !== void 0 ? _theme_base_ : '1',
            '-webkit-tap-highlight-color': 'transparent'
        },
        'body:has(dialog[open])': {
            overflow: 'hidden'
        },
        'h1': {
            fontSize: theme('fontSize.3xl'),
            lineHeight: (_theme_3xl_ = (_theme1 = theme('fontSize')) === null || _theme1 === void 0 ? void 0 : (_theme_3xl = _theme1['3xl']) === null || _theme_3xl === void 0 ? void 0 : _theme_3xl[1]) !== null && _theme_3xl_ !== void 0 ? _theme_3xl_ : '1',
            fontWeight: theme('fontWeight.medium')
        },
        'h2': {
            fontSize: theme('fontSize.2xl'),
            lineHeight: (_theme_2xl_ = (_theme2 = theme('fontSize')) === null || _theme2 === void 0 ? void 0 : (_theme_2xl = _theme2['2xl']) === null || _theme_2xl === void 0 ? void 0 : _theme_2xl[1]) !== null && _theme_2xl_ !== void 0 ? _theme_2xl_ : '1',
            fontWeight: theme('fontWeight.medium')
        },
        'h3': {
            fontSize: theme('fontSize.xl'),
            lineHeight: (_theme_xl_ = (_theme3 = theme('fontSize')) === null || _theme3 === void 0 ? void 0 : (_theme_xl = _theme3.xl) === null || _theme_xl === void 0 ? void 0 : _theme_xl[1]) !== null && _theme_xl_ !== void 0 ? _theme_xl_ : '1',
            fontWeight: theme('fontWeight.medium')
        },
        'h4': {
            fontSize: theme('fontSize.lg'),
            lineHeight: (_theme_lg_ = (_theme4 = theme('fontSize')) === null || _theme4 === void 0 ? void 0 : (_theme_lg = _theme4.lg) === null || _theme_lg === void 0 ? void 0 : _theme_lg[1]) !== null && _theme_lg_ !== void 0 ? _theme_lg_ : '1',
            fontWeight: theme('fontWeight.semibold')
        },
        'h5': {
            fontSize: theme('fontSize.base'),
            lineHeight: (_theme_base_1 = (_theme5 = theme('fontSize')) === null || _theme5 === void 0 ? void 0 : (_theme_base1 = _theme5.base) === null || _theme_base1 === void 0 ? void 0 : _theme_base1[1]) !== null && _theme_base_1 !== void 0 ? _theme_base_1 : '1',
            fontWeight: theme('fontWeight.semibold')
        },
        'h6': {
            fontSize: theme('fontSize.base'),
            lineHeight: (_theme_base_2 = (_theme6 = theme('fontSize')) === null || _theme6 === void 0 ? void 0 : (_theme_base2 = _theme6.base) === null || _theme_base2 === void 0 ? void 0 : _theme_base2[1]) !== null && _theme_base_2 !== void 0 ? _theme_base_2 : '1',
            fontWeight: theme('fontWeight.semibold')
        },
        'strong, b': {
            fontWeight: theme('fontWeight.semibold')
        },
        'ol': {
            listStyle: 'decimal'
        },
        [`@media (min-width: ${theme('screens.lg')})`]: {
            'h1': {
                fontSize: theme('fontSize.4xl'),
                lineHeight: (_theme_4xl_ = (_theme7 = theme('fontSize')) === null || _theme7 === void 0 ? void 0 : (_theme_4xl = _theme7['4xl']) === null || _theme_4xl === void 0 ? void 0 : _theme_4xl[1]) !== null && _theme_4xl_ !== void 0 ? _theme_4xl_ : '1'
            },
            'h2': {
                fontSize: theme('fontSize.3xl'),
                lineHeight: (_theme_3xl_1 = (_theme8 = theme('fontSize')) === null || _theme8 === void 0 ? void 0 : (_theme_3xl1 = _theme8['3xl']) === null || _theme_3xl1 === void 0 ? void 0 : _theme_3xl1[1]) !== null && _theme_3xl_1 !== void 0 ? _theme_3xl_1 : '1'
            }
        }
    });
    /**
     * CONTAINER:
     * Remove horizontal padding on nested containers,
     * used when dynamically rendering blocks in blocks.
     */ addComponents({
        '.container .container': {
            paddingLeft: theme('spacing.0'),
            paddingRight: theme('spacing.0')
        }
    });
    /**
     * Used to define starting values for properties set on an element
     * that you want to transition from when the element receives its first style update
     * Once we update to tailwind v4, I believe we can get rid of this
     * https://github.com/tailwindlabs/tailwindcss/pull/13329
     */ addVariant('starting', '@starting-style');
    /**
     * RICH TEXT:
     * Content not controlled by your application
     * like Contentful RichText, Markdown, etc.
     *
     * Parent classes:
     * - `.scl-rich-text` required
     * - `.scl-rich-text-list-center` optional, centers a list ul/ol
     * - `.scl-rich-text-list-column-2` optional, makes lists two columns at lg breakpoint
     * - `.scl-rich-text-list-column-3` optional, makes lists three columns at lg breakpoint
     *
     * Nested classes:
     * - `.scl-rich-text-block` required, apply this class to any nested block level elements
     */ addComponents({
        '.scl-rich-text': {
            /**
         * Base
         */ '& ::marker': {
                fontWeight: 'inherit'
            },
            /**
         * Spacing
         * NOTE: Order matters
         */ /* Spacing Rule #1: First child no spacing
         * using named elements for specificity
         */ '& > p:first-child': {
                marginTop: theme('spacing.0')
            },
            '& > ul:first-child, > ol:first-child': {
                marginTop: theme('spacing.0')
            },
            '& > h1:first-child, > h2:first-child, > h3:first-child, > h4:first-child, > h5:first-child, > h6:first-child, > hr:first-child, > .scl-rich-text-block:first-child': {
                marginTop: theme('spacing.0')
            },
            '& > hr': {
                marginTop: theme('spacing.0')
            },
            '& > .scl-rich-text-block': {
                marginTop: theme('spacing.0')
            },
            /* Spacing Rule #2: List follows anything */ '& > * + ul, > * + ol': {
                marginTop: theme('spacing.7')
            },
            /* Spacing Rule #2.1: List follows paragraph */ '& > p + ul, > p + ol': {
                marginTop: theme('spacing.4')
            },
            /* Spacing Rule #3: Heading following anything; also see large breakpoint overrides */ '& > * + h1, > * + h2, > * + h3, > * + h4, > * + h5, > * + h6': {
                marginTop: theme('spacing.12')
            },
            /* Spacing Rule #4: Heading following a List; also see large breakpoint overrides */ '& > ul + h1, > ul + h2, > ul + h3, > ul + h4, > ul + h5, > ul + h6, > ol + h1, > ol + h2, > ol + h3, > ol + h4, > ol + h5, > ol + h6': {
                marginTop: theme('spacing.9')
            },
            /* Spacing Rule #5: hr following anything; also see large breakpoint overrides */ '& > * + hr': {
                marginTop: theme('spacing.12')
            },
            /* Spacing Rule #6: hr following List; also see large breakpoint overrides */ '& > ul + hr, > ol + hr': {
                marginTop: theme('spacing.9')
            },
            /* Spacing Rule #7: Block following anything */ '& > * + .scl-rich-text-block': {
                marginTop: theme('spacing.8')
            },
            /* Spacing Rule #8: Block following List */ '& > ul + .scl-rich-text-block, > ol + .scl-rich-text-block': {
                marginTop: theme('spacing.5')
            },
            /* Spacing Rule #9: Paragrah following anything */ '& > * + p': {
                marginTop: theme('spacing.7')
            },
            /* Spacing Rule #10: Paragrah following List */ '& > ul + p, > ol + p': {
                marginTop: theme('spacing.4')
            },
            /* Spacing Rule #11 Paragraph follows an embedded entry */ '& > .scl-rich-text-block + p': {
                marginTop: theme('spacing.8')
            },
            /* Spacing Rule #12 Paragraph follows an HR; also see large breakpoint overrides */ '& > hr + p': {
                marginTop: theme('spacing.12')
            },
            /**
         * Lists
         */ /* List spacing */ '& ul, ol': {
                marginLeft: theme('spacing.5')
            },
            /* List styles type (3 levels deep) */ '& ul': {
                listStyleType: theme('listStyleType.disc'),
                '& ul': {
                    listStyleType: 'circle',
                    '& ul': {
                        listStyleType: 'square'
                    }
                }
            },
            '& ol': {
                listStyleType: theme('listStyleType.decimal'),
                '& ol': {
                    listStyleType: 'lower-alpha',
                    '& ol': {
                        listStyleType: 'lower-roman'
                    }
                }
            },
            /* List alignment */ '&.scl-rich-text-list-center': {
                '& > ul, > ol': {
                    display: 'inline-block',
                    textAlign: 'left'
                }
            },
            /* List item */ '& li': {
                paddingBottom: theme('spacing.3'),
                /* 12px */ breakInside: 'avoid-column'
            },
            '& li > p': {
                display: 'inline'
            },
            /* Large breakpoint */ [`@media (min-width: ${theme('screens.lg')})`]: {
                /* Spacing Rule #3: Heading following anything */ '& > * + h1, > * + h2, > * + h3, > * + h4, > * + h5, > * + h6': {
                    marginTop: theme('spacing.15')
                },
                /* Spacing Rule #4: Heading following List */ '& > ul + h1, > ul + h2, > ul + h3, > ul + h4, > ul + h5, > ul + h6, > ol + h1, > ol + h2, > ol + h3, > ol + h4, > ol + h5, > ol + h6': {
                    marginTop: theme('spacing.12')
                },
                /* Spacing Rule #5: HR following anything */ '& > * + hr': {
                    marginTop: theme('spacing.15')
                },
                /* Spacing Rule #6: HR following List */ '& > ul + hr, > ol + hr': {
                    marginTop: theme('spacing.12')
                },
                /* Spacing Rule #12: Paragraph follows an HR */ '& > hr + p': {
                    marginTop: theme('spacing.15')
                },
                /* List columns */ '&.scl-rich-text-list-column-2': {
                    '& > ul, > ol': {
                        columns: theme('columns.2'),
                        gap: theme('spacing.15')
                    }
                },
                '&.scl-rich-text-list-column-3': {
                    '& > ul, > ol': {
                        columns: theme('columns.3'),
                        gap: theme('spacing.15')
                    }
                }
            }
        }
    });
});
